import TableSearch from './table-search'
import SearchGrid from './SearchGrid'
import FooterBar from './footer-bar'
import Pagination from './pagination'
import InputValidate from './input-validate'
import InqueryResult from './inquery-result'
const globalComponents = [
  TableSearch,
  SearchGrid,
  Pagination,
  FooterBar,
  InputValidate,
  InqueryResult,
  SearchGrid
]

globalComponents.install = (Vue) => {
  globalComponents.map((component) => {
    Vue.component(component.name, component)
  })
}

export default globalComponents
